import { API_BASE_URL } from './api';

/** The only shape the backend generates; anything else is not worth a request. */
const TOKEN_PATTERN = /^[0-9a-f]{32}$/;

export type UnsubscribeResult = 'unsubscribed' | 'invalid' | 'failed';

export const isWellFormedUnsubscribeToken = (token: string | null): boolean =>
  token !== null && TOKEN_PATTERN.test(token);

/**
 * Turns off Email Notifications for the user the token names (RME-1362).
 *
 * Plain `fetch` rather than RTK Query: the unsubscribe page runs signed out,
 * outside the Redux store and Auth0, so there is no token to attach and
 * nothing to cache. A 404 or 400 means the link itself is bad; anything else
 * that fails is worth another try.
 */
export const unsubscribe = async (
  token: string
): Promise<UnsubscribeResult> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/unsubscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });
    if (response.ok) return 'unsubscribed';
    if (response.status === 400 || response.status === 404) return 'invalid';
    return 'failed';
  } catch {
    return 'failed';
  }
};
